import { IPagination } from "../interfaces/common/IPagination";
import { EAuditStatus, IAuditListFilters } from "../interfaces/IAudit";

export const mostRecentDesktopPagination: IPagination = { pageSize: 4, page: 1 };
export const mostRecentMobilePagination: IPagination = { pageSize: 3, page: 1 };
export const mostRecentFilters: IAuditListFilters = { status: EAuditStatus.Finished, roles: [] };

export const getAuditCountSearchParams = (filters: IAuditListFilters): IAuditListFilters => {
    let clearFilters: IAuditListFilters = {
        roles: [],
        owner: undefined,
        category: undefined,
        formType: undefined,
        dateRange: undefined,
        responsiblePerson: undefined,
        creator: undefined,
        freeText: undefined
    }
    return {
        ...filters,
        ...clearFilters,
        roles: filters.roles
    }
};


export const defaultPagination: IPagination = { pageSize: 10, page: 1 };
export const defaultAuditFilters: IAuditListFilters = { roles: [] };